export const ADD_WEB_PAGE_FROM_URL_DIALOG_FORM = 'add-web-page-from-url-dialog'
export const ADD_VIDEO_FROM_URL_DIALOG_FORM = 'add-video-from-url-dialog'
export const PAGE_VIDEO_RESTORED_MESSAGE =
  'Your video has been archived, please wait until we will recover it back for you'
